import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Accountant } from '../models/siteProvider.ts';
import { fetchSiteProviderAccountants } from '../api/site-provider.ts';

export default function useSiteProviderAccountants(
  id: string,
): UseQueryResult<Accountant[], Error> {
  return useQuery<Accountant[]>({
    queryKey: ['siteProviderAccountants', id],
    queryFn: () => fetchSiteProviderAccountants(id),
    enabled: !!id,
  });
}
